import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import copy from 'copy-to-clipboard';
import { BiEventType } from '../../biLogger/constants';
import BiButton from '../../biLogger/Components/SimpleBiButton';
import s from './DesktopSharePopup.scss';
// TODO: this should actually use C01 (SISU input) eventually but we dont have
// updated designs for that yet, so this is just an eyeballed mock
export var CopyButton = function (_a) {
    var text = _a.text;
    var t = useTranslation().t;
    var _b = useState(false), copied = _b[0], setCopied = _b[1];
    return (React.createElement("div", { className: s['copy-block'] },
        React.createElement("div", { className: s['copy-content'] },
            React.createElement("input", { className: s['copy-field'], value: text, readOnly: true })),
        React.createElement(BiButton, { biData: {
                evid: BiEventType.CLICK_COPY,
            }, className: s['copy-button'], onClick: function () {
                copy(text);
                setCopied(true);
            } }, t(copied ? 'share.copied' : 'share.copy'))));
};
CopyButton.displayName = 'CopyButton';
export default CopyButton;
//# sourceMappingURL=CopyButton.js.map